import "./phone_email_verify.css";
import phone_email_success from "../../../assets/manageaccounts/successIcon.png";
import { ProgressIndicator, TextInput, Button, Dropdown } from "pepsico-ds";
import React, { useState, useEffect } from "react";
import { Icon } from "pepsico-ds";
import { Link, useNavigate } from "react-router-dom";
import updateProfileService from "./update_profile.service";
import { useUserProfile } from "../../../common/user_profile_context";
import { toast,ToastContainer } from 'react-toastify';
import { useLoading } from "../../../loader";

const PhoneEmailVerification = ({ mode = 'phone', onClickCancel }) => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [phoneOtp, setPhoneOtp] = useState("");
  const [emailOtp, setEmailOtp] = useState("");
  const [email, setEmail] = useState("");
  const [isPhoneVerify, setIsPhoneVerify] = useState(false);
  const [isPhoneSuccess, setPhoneSuccess] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { showLoader, hideLoader } = useLoading();
  const { userProfile, loading } = useUserProfile();
  const isPhone = mode === "phone";
  const isCall = mode === "call";
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [countryCode, setCountryCode] = useState([]);
  const [dropdownRenderKey, setDropdownRenderKey] = useState(0);

  const [countryCodeOptions, setCountryCodeOptions] =useState([
    { displayText: "+93 - Afghanistan", id: "93" },
    { displayText: "+355 - Albania", id: "355" },
    { displayText: "+213 - Algeria", id: "213" },
    { displayText: "+1-684 - American Samoa", id: "1-684" },
    { displayText: "+376 - Andorra", id: "376" },
    { displayText: "+244 - Angola", id: "244" },
    { displayText: "+1-264 - Anguilla", id: "1-264" },
    { displayText: "+672 - Antarctica", id: "672" },
    { displayText: "+1-268 - Antigua and Barbuda", id: "1-268" },
    { displayText: "+54 - Argentina", id: "54" },
    { displayText: "+374 - Armenia", id: "374" },
    { displayText: "+297 - Aruba", id: "297" },
    { displayText: "+61 - Australia", id: "61" },
    { displayText: "+43 - Austria", id: "43" },
    { displayText: "+994 - Azerbaijan", id: "994" },
    { displayText: "+1-242 - Bahamas", id: "1-242" },
    { displayText: "+973 - Bahrain", id: "973" },
    { displayText: "+880 - Bangladesh", id: "880" },
    { displayText: "+1-246 - Barbados", id: "1-246" },
    { displayText: "+375 - Belarus", id: "375" },
    { displayText: "+32 - Belgium", id: "32" },
    { displayText: "+501 - Belize", id: "501" },
    { displayText: "+229 - Benin", id: "229" },
    { displayText: "+1-441 - Bermuda", id: "1-441" },
    { displayText: "+975 - Bhutan", id: "975" },
    { displayText: "+591 - Bolivia", id: "591" },
    { displayText: "+387 - Bosnia and Herzegovina", id: "387" },
    { displayText: "+267 - Botswana", id: "267" },
    { displayText: "+55 - Brazil", id: "55" },
    { displayText: "+246 - British Indian Ocean Territory", id: "246" },
    { displayText: "+1-284 - British Virgin Islands", id: "1-284" },
    { displayText: "+673 - Brunei", id: "673" },
    { displayText: "+359 - Bulgaria", id: "359" },
    { displayText: "+226 - Burkina Faso", id: "226" },
    { displayText: "+257 - Burundi", id: "257" },
    { displayText: "+855 - Cambodia", id: "855" },
    { displayText: "+237 - Cameroon", id: "237" },
    { displayText: "+238 - Cape Verde", id: "238" },
    { displayText: "+1-345 - Cayman Islands", id: "1-345" },
    { displayText: "+236 - Central African Republic", id: "236" },
    { displayText: "+235 - Chad", id: "235" },
    { displayText: "+56 - Chile", id: "56" },
    { displayText: "+86 - China", id: "86" },
    { displayText: "+57 - Colombia", id: "57" },
    { displayText: "+269 - Comoros", id: "269" },
    { displayText: "+682 - Cook Islands", id: "682" },
    { displayText: "+506 - Costa Rica", id: "506" },
    { displayText: "+385 - Croatia", id: "385" },
    { displayText: "+53 - Cuba", id: "53" },
    { displayText: "+599 - Curaçao", id: "599" },
    { displayText: "+357 - Cyprus", id: "357" },
    { displayText: "+420 - Czech Republic", id: "420" },
    { displayText: "+243 - DR Congo", id: "243" },
    { displayText: "+45 - Denmark", id: "45" },
    { displayText: "+253 - Djibouti", id: "253" },
    { displayText: "+1-767 - Dominica", id: "1-767" },
    { displayText: "+1-809,1-829,1-849 - Dominican Republic", id: "1-809,1-829,1-849" },
    { displayText: "+670 - East Timor", id: "670" },
    { displayText: "+593 - Ecuador", id: "593" },
    { displayText: "+20 - Egypt", id: "20" },
    { displayText: "+503 - El Salvador", id: "503" },
    { displayText: "+240 - Equatorial Guinea", id: "240" },
    { displayText: "+291 - Eritrea", id: "291" },
    { displayText: "+372 - Estonia", id: "372" },
    { displayText: "+251 - Ethiopia", id: "251" },
    { displayText: "+500 - Falkland Islands", id: "500" },
    { displayText: "+298 - Faroe Islands", id: "298" },
    { displayText: "+679 - Fiji", id: "679" },
    { displayText: "+358 - Finland", id: "358" },
    { displayText: "+33 - France", id: "33" },
    { displayText: "+689 - French Polynesia", id: "689" },
    { displayText: "+241 - Gabon", id: "241" },
    { displayText: "+220 - Gambia", id: "220" },
    { displayText: "+995 - Georgia", id: "995" },
    { displayText: "+49 - Germany", id: "49" },
    { displayText: "+233 - Ghana", id: "233" },
    { displayText: "+350 - Gibraltar", id: "350" },
    { displayText: "+30 - Greece", id: "30" },
    { displayText: "+299 - Greenland", id: "299" },
    { displayText: "+1-473 - Grenada", id: "1-473" },
    { displayText: "+1-671 - Guam", id: "1-671" },
    { displayText: "+502 - Guatemala", id: "502" },
    { displayText: "+44-1481 - Guernsey", id: "44-1481" },
    { displayText: "+224 - Guinea", id: "224" },
    { displayText: "+245 - Guinea-Bissau", id: "245" },
    { displayText: "+592 - Guyana", id: "592" },
    { displayText: "+509 - Haiti", id: "509" },
    { displayText: "+504 - Honduras", id: "504" },
    { displayText: "+852 - Hong Kong", id: "852" },
    { displayText: "+36 - Hungary", id: "36" },
    { displayText: "+354 - Iceland", id: "354" },
    { displayText: "+91 - India", id: "91" },
    { displayText: "+62 - Indonesia", id: "62" },
    { displayText: "+98 - Iran", id: "98" },
    { displayText: "+964 - Iraq", id: "964" },
    { displayText: "+353 - Ireland", id: "353" },
    { displayText: "+44-1624 - Isle of Man", id: "44-1624" },
    { displayText: "+972 - Israel", id: "972" },
    { displayText: "+39 - Italy", id: "39" },
    { displayText: "+225 - Ivory Coast", id: "225" },
    { displayText: "+1-876 - Jamaica", id: "1-876" },
    { displayText: "+81 - Japan", id: "81" },
    { displayText: "+44-1534 - Jersey", id: "44-1534" },
    { displayText: "+962 - Jordan", id: "962" },
    { displayText: "+254 - Kenya", id: "254" },
    { displayText: "+686 - Kiribati", id: "686" },
    { displayText: "+383 - Kosovo", id: "383" },
    { displayText: "+965 - Kuwait", id: "965" },
    { displayText: "+996 - Kyrgyzstan", id: "996" },
    { displayText: "+856 - Laos", id: "856" },
    { displayText: "+371 - Latvia", id: "371" },
    { displayText: "+961 - Lebanon", id: "961" },
    { displayText: "+266 - Lesotho", id: "266" },
    { displayText: "+231 - Liberia", id: "231" },
    { displayText: "+218 - Libya", id: "218" },
    { displayText: "+423 - Liechtenstein", id: "423" },
    { displayText: "+370 - Lithuania", id: "370" },
    { displayText: "+352 - Luxembourg", id: "352" },
    { displayText: "+853 - Macau", id: "853" },
    { displayText: "+389 - North Macedonia", id: "389" },
    { displayText: "+261 - Madagascar", id: "261" },
    { displayText: "+265 - Malawi", id: "265" },
    { displayText: "+60 - Malaysia", id: "60" },
    { displayText: "+960 - Maldives", id: "960" },
    { displayText: "+223 - Mali", id: "223" },
    { displayText: "+356 - Malta", id: "356" },
    { displayText: "+692 - Marshall Islands", id: "692" },
    { displayText: "+222 - Mauritania", id: "222" },
    { displayText: "+230 - Mauritius", id: "230" },
    { displayText: "+262 - Mayotte", id: "262" },
    { displayText: "+52 - Mexico", id: "52" },
    { displayText: "+691 - Micronesia", id: "691" },
    { displayText: "+373 - Moldova", id: "373" },
    { displayText: "+377 - Monaco", id: "377" },
    { displayText: "+976 - Mongolia", id: "976" },
    { displayText: "+382 - Montenegro", id: "382" },
    { displayText: "+1-664 - Montserrat", id: "1-664" },
    { displayText: "+212 - Morocco", id: "212" },
    { displayText: "+258 - Mozambique", id: "258" },
    { displayText: "+95 - Myanmar", id: "95" },
    { displayText: "+264 - Namibia", id: "264" },
    { displayText: "+674 - Nauru", id: "674" },
    { displayText: "+977 - Nepal", id: "977" },
    { displayText: "+31 - Netherlands", id: "31" },
    { displayText: "+687 - New Caledonia", id: "687" },
    { displayText: "+64 - New Zealand", id: "64" },
    { displayText: "+505 - Nicaragua", id: "505" },
    { displayText: "+227 - Niger", id: "227" },
    { displayText: "+234 - Nigeria", id: "234" },
    { displayText: "+683 - Niue", id: "683" },
    { displayText: "+850 - North Korea", id: "850" },
    { displayText: "+1-670 - Northern Mariana Islands", id: "1-670" },
    { displayText: "+47 - Norway", id: "47" },
    { displayText: "+968 - Oman", id: "968" },
    { displayText: "+92 - Pakistan", id: "92" },
    { displayText: "+680 - Palau", id: "680" },
    { displayText: "+970 - Palestine", id: "970" },
    { displayText: "+507 - Panama", id: "507" },
    { displayText: "+675 - Papua New Guinea", id: "675" },
    { displayText: "+595 - Paraguay", id: "595" },
    { displayText: "+51 - Peru", id: "51" },
    { displayText: "+63 - Philippines", id: "63" },
    { displayText: "+48 - Poland", id: "48" },
    { displayText: "+351 - Portugal", id: "351" },
    { displayText: "+1-787,1-939 - Puerto Rico", id: "1-787,1-939" },
    { displayText: "+974 - Qatar", id: "974" },
    { displayText: "+242 - Republic of the Congo", id: "242" },
    { displayText: "+40 - Romania", id: "40" },
    { displayText: "+7 - Russia", id: "7" },
    { displayText: "+250 - Rwanda", id: "250" },
    { displayText: "+590 - Saint Barthélemy / Saint Martin / Guadeloupe", id: "590" },
    { displayText: "+290 - Saint Helena", id: "290" },
    { displayText: "+1-869 - Saint Kitts and Nevis", id: "1-869" },
    { displayText: "+1-758 - Saint Lucia", id: "1-758" },
    { displayText: "+508 - Saint Pierre and Miquelon", id: "508" },
    { displayText: "+1-784 - Saint Vincent and the Grenadines", id: "1-784" },
    { displayText: "+685 - Samoa", id: "685" },
    { displayText: "+378 - San Marino", id: "378" },
    { displayText: "+239 - São Tomé and Príncipe", id: "239" },
    { displayText: "+966 - Saudi Arabia", id: "966" },
    { displayText: "+221 - Senegal", id: "221" },
    { displayText: "+381 - Serbia", id: "381" },
    { displayText: "+248 - Seychelles", id: "248" },
    { displayText: "+232 - Sierra Leone", id: "232" },
    { displayText: "+65 - Singapore", id: "65" },
    { displayText: "+1-721 - Sint Maarten", id: "1-721" },
    { displayText: "+421 - Slovakia", id: "421" },
    { displayText: "+386 - Slovenia", id: "386" },
    { displayText: "+677 - Solomon Islands", id: "677" },
    { displayText: "+252 - Somalia", id: "252" },
    { displayText: "+27 - South Africa", id: "27" },
    { displayText: "+82 - South Korea", id: "82" },
    { displayText: "+211 - South Sudan", id: "211" },
    { displayText: "+34 - Spain", id: "34" },
    { displayText: "+94 - Sri Lanka", id: "94" },
    { displayText: "+249 - Sudan", id: "249" },
    { displayText: "+597 - Suriname", id: "597" },
    { displayText: "+268 - Eswatini (Swaziland)", id: "268" },
    { displayText: "+46 - Sweden", id: "46" },
    { displayText: "+41 - Switzerland", id: "41" },
    { displayText: "+963 - Syria", id: "963" },
    { displayText: "+886 - Taiwan", id: "886" },
    { displayText: "+992 - Tajikistan", id: "992" },
    { displayText: "+255 - Tanzania", id: "255" },
    { displayText: "+66 - Thailand", id: "66" },
    { displayText: "+228 - Togo", id: "228" },
    { displayText: "+690 - Tokelau", id: "690" },
    { displayText: "+676 - Tonga", id: "676" },
    { displayText: "+1-868 - Trinidad and Tobago", id: "1-868" },
    { displayText: "+216 - Tunisia", id: "216" },
    { displayText: "+90 - Turkey", id: "90" },
    { displayText: "+993 - Turkmenistan", id: "993" },
    { displayText: "+1-649 - Turks and Caicos Islands", id: "1-649" },
    { displayText: "+688 - Tuvalu", id: "688" },
    { displayText: "+1-340 - U.S. Virgin Islands", id: "1-340" },
    { displayText: "+256 - Uganda", id: "256" },
    { displayText: "+380 - Ukraine", id: "380" },
    { displayText: "+971 - United Arab Emirates", id: "971" },
    { displayText: "+44 - United Kingdom", id: "44" },
    { displayText: "+1 - United States / Canada", id: "1" },
    { displayText: "+598 - Uruguay", id: "598" },
    { displayText: "+998 - Uzbekistan", id: "998" },
    { displayText: "+678 - Vanuatu", id: "678" },
    { displayText: "+379 - Vatican City", id: "379" },
    { displayText: "+58 - Venezuela", id: "58" },
    { displayText: "+84 - Vietnam", id: "84" },
    { displayText: "+681 - Wallis and Futuna", id: "681" },
    { displayText: "+967 - Yemen", id: "967" },
    { displayText: "+260 - Zambia", id: "260" },
    { displayText: "+263 - Zimbabwe", id: "263" }
  ]);

    useEffect(()=>{
    updateProfileService.getUserDetails({ gpid:userProfile?.gpId}).then((resp)=>{
      const countryCodeRespOption = [{
                id: resp?.profileDetails?.ext,
                displayText: resp?.profileDetails?.ext}]
      setCountryCode(countryCodeRespOption);
      resp?.profileDetails?.phone && setPhone(resp?.profileDetails?.phone);
      if(!countryCodeOptions.find((val)=>val.id == resp?.profileDetails?.ext)){
        setCountryCodeOptions((prev)=>([...prev,...countryCodeRespOption]))
        }
    })
  },[])

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (loading || !userProfile) return;

  }, [loading, userProfile]);

  const setCountryCodeSafely = (option) => {
    setCountryCode([option]);      // SAME reference
    setDropdownRenderKey(k => k + 1); // force close
  };

  const handlePhoneChange = (e) => {

    setPhone(e.target.value);
  }

  const handlePhoneOtpChange = (e) => {
    setPhoneOtp(e.target.value);
  }

  const handleEmailOtpChange = (e) => {
    setEmailOtp(e.target.value);
  }

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  }

  const onClickSendCode = async () => {
    setIsLoading(true);
    const payload = isPhone ? {
      gpid: userProfile.gpId,
      mobileNumber: phone,
      countryCode: countryCode[0]?.displayText?.split('-')?.[0]?.trim(),
      channelType: 'MOBILE',
      emailId: userProfile?.email
    }
      : isCall ? {
        gpid: userProfile.gpId,
        mobileNumber: phone,
        countryCode: countryCode[0]?.displayText?.split('-')?.[0]?.trim(),
        channelType: 'VOICE',
        emailId: userProfile?.email
      } : {
        gpid: userProfile.gpId,
        mobileNumber: userProfile?.mobileNumber,
        countryCode: userProfile?.countryCode,
        emailId: email,
        channelType: 'EMAIL',
      };
    try {
      showLoader();
      const res = await updateProfileService.getCodeForPhoneEmailVerification(payload);
      if (res?.responseStatus !== 'Success' || res?.status !== 'Success') {
        setIsPhoneVerify(false);
        hideLoader();
        // return toast.error(res?.responseMessage || "Failed to send code. Please try again.");
      }
      setIsPhoneVerify(true);
      setCurrentStep(prev => prev + 1);
      toast.success("Verification code sent successfully.");
    } catch (error) {
      setIsPhoneVerify(true);
      hideLoader();
      setErrorMessage("Failed to send code. Please try again.");
      toast.error("Failed to send code. Please try again.");
    } finally {
      setCurrentStep(prev => prev + 1);
      setIsLoading(false);
      hideLoader();
    }
  }

  const onClickPreviuos = () => {
    setIsPhoneVerify(false);
    setCurrentStep(prev => prev - 1);
  }

  const onClickContinue = () => {
    setIsLoading(true);
    if(isPhone || isCall){
      const payload = isPhone ? {
        gpid: userProfile.gpId,
        otp: phoneOtp,
        channelType: 'Mobile',
        mobileNumber: phone,
        countryCode: countryCode[0]?.displayText?.split('-')?.[0]?.trim(),
        emailId: userProfile?.email
      } :  {
        gpid: userProfile.gpId,
        otp: phoneOtp,
        channelType: 'VOICE',
        mobileNumber: phone,
        countryCode: countryCode[0]?.displayText?.split('-')?.[0]?.trim(),
        emailId: userProfile?.email
      }
      showLoader();
      updateProfileService.verifyPhoneEmailCode(payload)
      .then((response) => {
        if(response?.responseStatus !== 'Success' || response?.responseMessage?.toLowerCase()?.split(" ").includes("expired") || response?.responseMessage?.toLowerCase()?.split(" ").includes("incorrect")){
          toast.error(response?.responseMessage);
          updateProfileService.updatePhoneNumber({
            "gpid": userProfile.gpId,
            "pepOTP": phoneOtp,
            "channelType": isPhone ? "MOBILE" : "VOICE",
            "mobileNumber": phone,
            "countryCode": countryCode[0]?.displayText?.split('-')?.[0]?.trim(),
          }).then((response)=>{
            if(response?.responseStatus !== 'Success'){
              toast.error("Failed to update phone number.")
              return;
            }
            setPhoneSuccess(true);
          }).catch(()=>{toast.error("Failed to update phone number.")})
        }else{
          toast.success("Verification successful.");
          updateProfileService.updatePhoneNumber({
            "gpid": userProfile.gpId,
            "pepOTP": phoneOtp,
            "channelType": isPhone ? "MOBILE" : "VOICE",
            "mobileNumber": phone,
            "countryCode": countryCode[0]?.displayText?.split('-')?.[0]?.trim(),
          }).then((response)=>{
            if(response?.statusCode !== 200){
              toast.error("Failed to update phone number.")
              return;
            }
            setPhoneSuccess(true);
          }).catch(()=>{toast.error("Failed to update phone number.")})

          
          hideLoader();
          localStorage.setItem((isPhone || isCall) ? 'isPhoneVerified' : 'isEmailVerified', 'true');
        }
        hideLoader();
      })
      .catch(() => {
        toast.error("Verification failed. Please check the code and try again.");
        hideLoader();
        setErrorMessage("Verification failed. Please check the code and try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
    }
    else{
      const payload = {
      gpid: userProfile.gpId,
      otp: emailOtp,
      emailId: email,
      mobileNumber: userProfile?.mobileNumber,
      countryCode: userProfile?.countryCode,
      channelType: 'EMAIL',
    };
    showLoader();
     updateProfileService.verifyEmailCode(payload)
      .then(() => {
        setPhoneSuccess(true);
        hideLoader();
      })
      .catch(() => {
        hideLoader();
        setErrorMessage("Verification failed. Please check the code and try again.");
      })
      .finally(() => {
        setIsLoading(false);
        hideLoader();
      });
    }
  }

  const onClickForward = () => {
    setIsLoading(true);
    const payload = isPhone ? {
      gpid: userProfile.gpId,
      pepOTP: phoneOtp,
      channelType: 'MOBILE',
      mobileNumber: phone,
      countryCode: countryCode[0]?.displayText?.split('-')?.[0]?.trim(),
      // emailId: userProfile?.email
    }
    : isCall ? {
      gpid: userProfile.gpId,
      pepOTP: phoneOtp,
      channelType: 'VOICE',
      mobileNumber: phone,
      countryCode: countryCode[0]?.displayText?.split('-')?.[0]?.trim(),
    } : {
      gpid: userProfile.gpId,
      pepOTP: emailOtp,
      emailId: email,
      mobileNumber: userProfile?.mobileNumber,
      countryCode: userProfile?.countryCode,
      channelType: 'EMAIL',
    };
    updateProfileService.updatePhoneEmailCode(payload)
      .then(() => {
        setIsLoading(false);
        // window.location.reload();
      })
      .catch(() => {
        setIsLoading(false);
        setErrorMessage("Verification failed. Please check the code and try again.");
      })
  }

  const onClickBackward = () => {
    resetVerificationFlow();
  }

  const resetVerificationFlow = () => {
    setPhone("");
    setPhoneOtp("");
    setEmailOtp("");
    setEmail("");
    setIsPhoneVerify(false);
    setPhoneSuccess(false);
    setCurrentStep(1);
  };

  const phoneTextInput = () => (
    <>
      <div className="flex align-items-end mobile-verify-field">
        <Dropdown
            key={dropdownRenderKey}
            childList={countryCodeOptions?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
            label={"Mobile"}
            placeholder="+1"
            selection="single"
            isClearable={false}
            // helperText="Help: Select Country Code"
            size="small"
            setSelectedValue={(selected) => { selected?.[0] && setCountryCodeSafely(selected?.[0]); }}
            selectedValue={countryCode}
            // value={countryCode}
        />
        <TextInput
          className=""
          feedbackType="info"
          inputSize="medium"
          inputMode="numeric"
          maxLength={10}
          label=""
          required
          onKeyDown={(e) => {
            if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Delete" && e.key !== "ArrowLeft" && e.key !== "ArrowRight" && e.key !== "Tab") {
                e.preventDefault();
            }
          }}
          onChange={(e) => {
            let val = e.target.value;
            val = val.replace(/\D/g, "");
            if (val.length > 10) {
                val = val.slice(0, 10);
            }
            handlePhoneChange(e);
          }}
          placeholderText="Type Here"
          
          showLabelIcon={false}
          value={phone}
          // style={{marginTop: "16px"}}
          // suffixType="none"
          type="tel"
        />
      </div>
      {isNaN(phone)?<div className="feedback $font-xsmall-regular info" role="feedback" style={{alignSelf:"start"}}>
        <span className="icon $color-icon small material-icons-outlined" role="img" style={{fontSize: "16px", marginRight: "0.25rem"}}>info</span>
        Please enter number only
      </div>:null}
      <div className="feedback grey $font-xsmall-regular info" role="feedback" style={{alignSelf:"start"}}>
        <span className="icon $color-icon small material-icons-outlined" role="img" style={{fontSize: "16px", marginRight: "0.25rem"}}>info</span>
        Help: Select country code 
      </div>
    </>
  );

  const emailTextInput = () => (
    <TextInput
      className=""
      inputSize="medium"
      label="Non-pepsico Email"
      required
      onChange={handleEmailChange}
      onUpdate={function NAe() { }}
      placeholderText="Type Here"
      showLabelIcon={false}
      value={email}
      // style={{marginTop: "16px"}}
      suffixType="none"
      type="email"
    />
  );

  const OtpInputBox = () => (
    <>
    <TextInput
      className=""
      feedbackType="info"
      inputSize="medium"
      label="One-time code"
      required
      onChange={(isPhone || isCall) ? handlePhoneOtpChange : handleEmailOtpChange}
      onUpdate={function NAe() { }}
      placeholderText="Type Here"
      showLabelIcon={false}
      value={(isPhone || isCall) ? phoneOtp : emailOtp}
      // style={{marginTop: "16px"}}
      suffixType="none"
      type="number"
    />
    <div className="feedback grey $font-xsmall-regular info" role="feedback" style={{alignSelf:"start"}}>
      <span className="icon $color-icon small material-icons-outlined" role="img" style={{fontSize: "16px", marginRight: "0.25rem"}}>info</span>
      8 digit number 
    </div>
    </>
  );

  const verificationBtn = () => (
    // <div className={`${isMobile ? "mobile-verification-button-group" : "verification-button-group"}`}>
    <div className="verification-button-group">
      <Button
        className=""
        size="medium"
        style={{}}
        text="Cancel"
        variant="secondary"
        onClick={onClickCancel}
      />
      <Button
        className=""
        size="medium"
        style={{}}
        text="Send code"
        variant="primary"
        disabled={(isPhone || isCall) ? (!phone?.trim() || isNaN(phone)) : !email?.trim()}
        onClick={onClickSendCode}
      />
    </div>
  );

  const OtpVerificationBtn = () => (
    <div className={`${isMobile ? "mobile-verification-button-group" : "phone-verification-button-group"}`}>
      <Button
        className=""
        size="medium"
        style={{}}
        text="Previous"
        variant="secondary"
        onClick={onClickPreviuos}
      />
      <Button
        className=""
        size="medium"
        style={{}}
        text="Continue"
        variant="primary"
        disabled={(isPhone || isCall) ? (!phoneOtp.trim() || isLoading) : ( !emailOtp.trim() || isLoading)}
        onClick={onClickContinue}
      />
    </div>
  )



  const renderDesktop = () => {
    return !isPhoneSuccess ? (
      <div id="update_emp_phone_email" className="update-profile-container">
        <div className="phone-update-container">
          {/* <div> */}
          <h6 style={{ fontWeight: "700", color: "#616161" }}>Update Phone</h6>
          {/* <ProgressIndicator
            className=""
            currentStep={currentStep}
            // completed = {true}
            orientation="horizontal"
            showStepNumber
            steps={2}
            style={{}}
            size="Xsmall"
            titles={[
              {
                title: (isPhone || isCall) ? 'Phone update' : 'Email Update',
              },
              {
                title: (isPhone || isCall) ? 'Verify phone' : 'Verify Email',
              }
            ]}
          /> */}
          {/* </div> */}

          {/* Form Box */}
          {!isPhoneVerify ? (
            <div className="form-box px-3 mt-3">
              <h3>{(isPhone || isCall) ? "STEP 1 PHONE UPDATE" : "STEP 1 NON-PEPSICO EMAIL UPDATE"}</h3>
              <p>{(isPhone || isCall) ? "Please provide your phone details" : "Please provide your email details"}</p>
              <small style={{ fontSize: "14px", color: "#616161" }}>Standard rates may apply.</small>
              <div style={{ marginBottom: "20px" }}></div>
              {(isPhone || isCall) ? (
                phoneTextInput()
              ) : (
                emailTextInput()
              )}

              {/* Buttons */}
              {verificationBtn()}
            </div>
          ) : (
            <div className="phone-form-box">
              <h3>{(isPhone || isCall) ? "STEP 2 VERIFY YOUR PHONE" : "STEP 2 VERIFY YOUR EMAIL"}</h3>
              <small style={{ fontSize: "14px", color: "#616161", textAlign: "left" }}>{isCall ? "Enter the code you hear to:" : "We sent a code via SMS to:"}</small>
              <p style={{ fontSize: "16px" }}>{(isPhone || isCall) ? `XXX-XXXX-${phone.slice(-4)}` : `XXX-XXXX-${email.slice(-13)}`}</p>
              <div style={{ marginBottom: "12px" }}></div>
              {OtpInputBox()}
              <br></br>
              <div className="phone-resend-code">
                <small style={{ fontSize: "12px", color: "#616161", textAlign: "left" }}>You didn't receive a code </small>
                <p style={{ fontSize: "12px", color: "#005CBC", fontWeight: "bold", cursor: "pointer" }} onClick={onClickSendCode}>Resend code</p>
              </div>

              {/* Buttons */}
              {OtpVerificationBtn()}
            </div>
          )}

        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
          <button className="phone-cancel-button" onClick={onClickCancel}>Cancel <Icon
            alt="alt value"
            icon="close"
            size="large"
            style={{ marginLeft: "8px" }}
          /></button>
        </div>
      </div>) : (
      <PhoneEmailSuccess onClickRightArrow={onClickForward} onClickLeftArrow={onClickBackward} isPhone={isPhone} isMobile={isMobile} phone={phone}  email={email} isCall={isCall} navigate={navigate}/>
    )

  }

  const renderMobile = () => {
    return !isPhoneSuccess ? (
      <div id="update_emp_phone_email" className="update-profile-container">
        <div className="phone-update-container">
          <h6 style={{ fontWeight: "700", color: "#616161" }}>Update Phone</h6>
          <div className={currentStep === 1 ? 'step-one-wrapper' : 'step-other-wrapper'}>

            <ProgressIndicator
              className=""
              currentStep={currentStep}
              onStepClick={function oFe() { }}
              // completed = {true}
              orientation="vertical"
              showStepNumber
              steps={2}
              style={{}}
              size="Xsmall"
              titles={[
                {
                  title: (isPhone || isCall) ? 'Phone update' : 'Email Update',
                },
                {
                  title: (isPhone || isCall) ? 'Verify phone' : 'Verify Email',
                }
              ]}
            />
          </div>

          {/* Form Box */}
          {!isPhoneVerify ? (
            <div className="mobile-form-box">
              <p>{(isPhone || isCall) ? "Please provide your phone details" : "Please provide your email details"}</p>
              <small className="detailsValue" style={{ marginLeft: 30 }}>Standard rates may apply.</small>
              <div style={{ marginBottom: "30px" }}></div>
              {(isPhone || isCall) ? (
                phoneTextInput()
              ) : (
                emailTextInput()
              )}

              {/* Buttons */}
              {verificationBtn()}

            </div>
          ) : (
            <div className="mobile-form-box">
              <div style={{ marginBottom: "12px", marginLeft: "12px" }}>
                <small className="detailsValue">We send a code via sms to </small>
                <p className="mobile-number-label">{(isPhone || isCall) ? `XXX-XXXX-${phone.slice(-4)}` : `XXX-XXXX-${email.slice(-13)}`}</p>
              </div>
              {OtpInputBox()}
              <br></br>
              <div className="mobile-email-resend-code">
                <span className="resend-message">You didn't receive a code? </span>
                <span className="resend-link" style={{cursor:"pointer"}} onClick={onClickSendCode}>Resend code</span>
              </div>



              {/* Buttons */}
              {OtpVerificationBtn()}
            </div>
          )}

        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "16px" }}>
          <button className="phone-cancel-button" onClick={onClickCancel}>Cancel<Icon
            alt="alt value"
            icon="close"
            size="large"
            style={{ marginLeft: "8px" }}
          /></button>
        </div>
      </div>) : (
      <PhoneEmailSuccess onClickRightArrow={onClickForward} onClickLeftArrow={onClickBackward} isPhone={isPhone} isMobile={isMobile} phone={phone}  email={email} isCall={isCall} navigate={navigate}/>
    )
  }


  return isMobile ? renderMobile() : renderDesktop();



}

const PhoneEmailSuccess = ({ onClickLeftArrow, onClickRightArrow, isPhone, isMobile, isCall, phone,  email, navigate }) => (
  <div className="success-container d-flex justify-content-center">
    <div className="success-card">
      <h5>Success!</h5>
      <small className="verified-text">We have verified:</small>
      <div className="verified-info">{(isPhone || isCall) ? "Phone" : "Email"}: <span>{(isPhone || isCall) ? `XXX-XXXX-${phone.slice(-4)}` : `XXX-XXXX-${email.slice(-13)}`}</span></div>

      <div className="success-icon">
        <img
          src={phone_email_success}
          alt="Success"
        />
      </div>

      <div className="manage-account-text">
        You can change this at any time in <br />
      </div>
        <Link to="/myidmPortal">
          <span className="manage-my-account">Manage my Account</span>
        </Link>
      <div className={`${isMobile ? "mobile-success-btn d-flex justify-content-center mt-3" : "phone-verification-button-group d-flex justify-content-center mt-3"}`}>
        <Button
          className=""
          size="medium"
          style={{}}
          text="Done"
          variant="primary"
          onClick={()=>navigate("/myidmPortal")}
        />
      </div>
      {/* {!isMobile && (
        <div className="bottom-links">
          <div className="left-link" onClick={onClickLeftArrow}><Icon
            alt="alt value"
            icon="arrow_back"
            size="large"
            style={{ marginRight: "4px", fontSize: "18px" }}
          />{(isPhone || isCall) ? 'Verify phone' : 'Verify email'}</div>
          <div className="right-link" onClick={onClickRightArrow}>Update profile<Icon
            alt="alt value"
            icon="arrow_forward"
            size="large"
            style={{ marginLeft: "4px", fontSize: "18px" }}
          /></div>
        </div>
      )} */}
    </div>
  </div>
);


export default PhoneEmailVerification;